@if (subscription()) {
    <div class="container">
        <div class="row justify-content-between">
            <app-breadcrumb [crumbs]="crumbs" class="col"></app-breadcrumb>
            <button (click)="openDelete($event)" color="warn" mat-icon-button>
                <mat-icon fontIcon="fa-trash" fontSet="fas"></mat-icon>
            </button>
        </div>
        <h1>Subscription #{{subscription().id}} - {{subscription().company?.name ?? 'To be announced'}}</h1>

        @if (form()) {
            <div [formGroup]="form()" class="row gap-3">
                <div class="col">
                    <b>Bedrijf</b>
                    <div class="row">
                        <ng-select [items]="companies()" [searchable]="true" bindLabel="name" bindValue="id" formControlName="company_id"></ng-select>
                    </div>
                </div>
                <div class="col-auto">
                    <b>Beschrijving op invoice (empty = product name):</b>
                    <div class="row">
                        <mat-form-field>
                            <input formControlName="description" matInput name="description" placeholder="Beschrijving"><br>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-auto">
                    <b>Interne opmerking:</b>
                    <div class="row">
                        <mat-form-field>
                            <input formControlName="comment" matInput name="comment" placeholder="Opmerking"><br>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-auto">
                    <b>Optellings URL:</b>
                    <div class="row">
                        <mat-form-field>
                            <input formControlName="count_url" matInput name="count_url" placeholder="Optellings url"><br>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-auto">
                    <b>Optelling:</b>
                    <div class="row">
                        <mat-form-field>
                            <input formControlName="count" matInput name="count" placeholder="Optelling" type="number"><br>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-auto">
                    <b>Prijs:</b>
                    <div class="row">
                        <mat-form-field>
                            <input formControlName="price" matInput name="price" placeholder="Prijs" step="0.01" type="number"><br>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-auto">
                    <b>Herhaal frequentie</b>
                    <div class="row">
                        <ng-select [searchable]="true" formControlName="repeat">
                            <ng-option value="month">Month</ng-option>
                            <ng-option value="quarter">Quarter</ng-option>
                            <ng-option value="year">Year</ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="col-auto">
                    <b>Laatste facturatie datum</b>
                    <div>
                        <mat-form-field>
                            <input
                                (focus)="pickerStart.open()"
                                [matDatepicker]="pickerStart"
                                formControlName="last_date"
                                matInput
                                placeholder="Laatste facturatie datum">
                            <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                            <mat-datepicker #pickerStart></mat-datepicker>
                            <mat-error [control]="form().get('last_date')"></mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <button (click)="save()" class="btn btn-primary">Opslaan</button>
            </div>
        }

        <pre class="json-codeblock p-2 mt-3">{{subscription() | json}}</pre>
    </div>
}
